import { MediaView } from 'components';
import type { TLightboxMedia } from '../../MediaLightbox';

type Props = {
  className?: string;
  onLoad?: () => void;
  listMedia: { type: string; url: string; fileName?: string }[];
  roundedTop?: string;
  roundedBottom?: string;
  onMediaClick?: (media: TLightboxMedia) => void;
};

function ChatMediaView({
  className,
  onLoad,
  listMedia,
  roundedTop,
  roundedBottom = 'rounded-b-xl',
  onMediaClick,
}: Props) {
  return (
    <>
      {listMedia?.map((media, index) => (
        <MediaView
          key={index}
          className={`${className} ${index === 0 && roundedTop} ${
            index === listMedia?.length - 1 && roundedBottom
          }`}
          {...media}
          onLoad={onLoad}
          onClick={onMediaClick ? () => onMediaClick({ url: media.url }) : undefined}
          videoOptions={{
            controls: true,
            isAutoPlayVideo: false,
            // チャットの動画はタップ強制全画面にせず、コントロールでインライン再生する
            isFullscreenOnclick: false,
          }}
        />
      ))}
    </>
  );
}

export default ChatMediaView;
